export function isValidInput(input: any): boolean {
    const cleanedInput: string = (input || '').toString().trim();

    if(cleanedInput === '')
        return false;

    return true;
}